


































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Documents, HomeSummary, UserJob } from '@/types';
import { getMyDocuments, getUserData } from '@/api';
import { NoDocumentsFoundMessage, NoDocumentSearchResultsFoundMessage, Phases, ActionType, ModalType } from '@/constants';
import { getRememberMe, hideLoader, showLoader, userHomeSelection } from '@/util';
import { getUniqueJobs } from './services/service';
import BreadCrumbs from '@/components/bread-crumbs/BreadCrumbs.vue';
import MyDocumentsList from './components/MyDocumentsList.vue';

export default Vue.extend({
  name: 'MyDocuments',
  components: {
    MyDocumentsList,
    BreadCrumbs,
    NotificationModal: () => import('@/components/modals/NotificationModal.vue')
  },
  data () {
    return {
      isInactivejob: false,
      selectedJobId: '',
      sortByDate: -1,
      phases: Phases,
      phaseSelected: 'All',
      filterDocuments: [] as Documents[],
      documents: [] as Documents[],
      dropdowns: {
        sort: false,
        phase: false,
        jobs: false
      },
      search: '',
      documentNotFound: {} as any,
      divisionId: '',
      isVisibleNotificationModal: false,
      modalData: {} as any,
      ModalType
    };
  },
  computed: {
    ...mapGetters([
      'signedIn',
      'allJobs',
      'jobs',
      'hasUserData',
      'badges',
      'isLoggedInAsAdmin'
    ]),
    newDocumentAvailable () {
      let documentsAdded = 0;
      this.documents.forEach((doc) => {
        if (doc.newDocument) {
          documentsAdded++;
        }
      });
      return documentsAdded;
    },
    allJobList (): UserJob[] {
      return getUniqueJobs(this.allJobs);
    }
  },
  watch: {
    sortByDate () {
      this.sortDocumentsByDate();
    }
  },
  mounted () {
    this.fetchDocuments();
  },
  async created () {
    this.selectedJobId = getRememberMe() as string;
    if (!this.selectedJobId) {
      if (!this.hasUserData) {
        await getUserData();
        this.selectedJobId = userHomeSelection();
      }
    }
    this.divisionId = this.jobs.filter((data: any) => data.jobNumber === this.selectedJobId)[0].divisionId;
    window.addEventListener('click', this.hideDropDowns);
  },
  beforeDestroy () {
    window.removeEventListener('click', this.hideDropDowns);
  },
  methods: {
    hideDropDowns (e: Event) {
      const dropdown = document.querySelector('.dropdown-show');
      if (dropdown && !dropdown.contains(e.target as Node)) {
        this.dropdowns.phase = false;
        this.dropdowns.sort = false;
        this.dropdowns.jobs = false;
      }
    },
    async newJobSelectedJob (userJob: UserJob) {
      if (!(this.selectedJobId === userJob.jobNumber)) {
        this.isInactivejob = !(this.jobs.some((job: HomeSummary) => job.jobNumber === userJob.jobNumber));
        this.selectedJobId = userJob.jobNumber;
        this.divisionId = userJob.divisionId;
        await this.fetchDocuments();
      }
    },
    async fetchDocuments () {
      this.documentNotFound = {};
      showLoader();
      const selectedHome = this.selectedJobId;
      selectedHome && getMyDocuments(selectedHome, this.divisionId, this.phaseSelected, {}).then((data) => {
        if (data) {
          this.documents = data;
          this.filterDocuments = this.documents;
          if (!this.filterDocuments.length) {
            this.documentNotFound = NoDocumentsFoundMessage;
          }
          this.search && this.searchDocuments();
          this.sortDocumentsByDate();
          hideLoader();
          if (this.badges.documents && !this.isLoggedInAsAdmin) {
            this.$store.dispatch(ActionType.CLEAR_BADGE, 'documents');
          }
        }
      });
    },
    searchDocuments () {
      this.documentNotFound = {};
      this.filterDocuments = [];
      this.filterDocuments = this.documents.filter(document => {
        return (document.title.toLowerCase().includes(this.search.toLowerCase()));
      });
      if (!this.filterDocuments.length) {
        this.documentNotFound = NoDocumentSearchResultsFoundMessage(this.search);
      }
    },
    sortDocumentsByDate () {
      this.filterDocuments.sort((first: any, secound: any) => {
        if (this.sortByDate === 1) {
          return this.compare(first.modifiedDate, secound.modifiedDate);
        }
        return this.compare(secound.modifiedDate, first.modifiedDate);
      });
    },
    compare (first: any, secound: any) {
      if (first < secound) {
        return -1;
      }
      if (first > secound) {
        return 1;
      }
      return 0;
    },
    toggleDocumentDropdowns (dropdown: string) {
        type documentDropdown = 'phase' | 'sort' | 'jobs';
        for (const [key, value] of Object.entries(this.dropdowns)) {
          if (key === dropdown) {
            this.dropdowns[key as documentDropdown] = !this.dropdowns[key as documentDropdown];
          } else {
            this.dropdowns[key as documentDropdown] = false;
          }
        }
    },
    toggleSortOptions () {
      this.sortByDate = this.sortByDate === -1 ? 1 : -1;
    },
    reset () {
      this.search = '';
      this.sortByDate = -1;
    },
    selectPhase (phase: string) {
      if (this.phaseSelected === phase) {
        this.filterDocuments = this.documents;
      } else {
        this.phaseSelected = phase;
        this.fetchDocuments();
      }
      if (!this.filterDocuments.length) {
        this.documentNotFound = NoDocumentsFoundMessage;
      }
    },
    fallback () {
      this.reset();
      this.selectPhase('All');
    },
    showNotificationModal (data: any) {
      this.isVisibleNotificationModal = true;
      this.modalData = data;
    }
  }
})
